import { FC, PropsWithChildren } from "react";

import { useAppContext } from "web/context/app";

import classes from "./section.scss";

interface ICheckoutTourismDomesticSectionProps {
  className?: string;
  title?: string;
  subtitle?: string;
}

const CheckoutTourismDomesticSection: FC<
  PropsWithChildren<ICheckoutTourismDomesticSectionProps>
> = ({ className = "", children, title = "", subtitle = "" }) => {
  const { isMobile } = useAppContext();
  const HeadingTag = isMobile ? "h2" : "h3";

  return children || title || subtitle ? (
    <section className={className || classes.root}>
      {title ? (
        <HeadingTag className={classes.title}>{title}</HeadingTag>
      ) : null}
      {subtitle ? (
        <strong className={classes.subtitle}>{subtitle}</strong>
      ) : null}
      {children}
    </section>
  ) : null;
};

export default CheckoutTourismDomesticSection;
